let cartDrawerScrollPosition = 0;

function isIntelligemsCartRedesignEnabled() {
  return (
    document.documentElement.classList.contains('ig-cart-redesign') ||
    document.documentElement.classList.contains('intelligems-cart-redesign') ||
    document.documentElement.dataset.intelligemsCartRedesign === 'true' ||
    document.documentElement.dataset.igCartRedesign === 'true' ||
    (document.body && document.body.classList.contains('ig-cart-redesign')) ||
    (document.body && document.body.classList.contains('intelligems-cart-redesign')) ||
    (document.body && document.body.dataset.intelligemsCartRedesign === 'true') ||
    (document.body && document.body.dataset.igCartRedesign === 'true')
  );
}

function ensureCartRedesignStylesheet(cartDrawer) {
  if (!cartDrawer) return;

  const stylesheetHref = cartDrawer.dataset.cartRedesignStylesheet;
  if (!stylesheetHref) return;

  const existingStylesheet = document.querySelector(`link[data-cart-redesign-stylesheet="${stylesheetHref}"]`);
  if (existingStylesheet) return;

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = stylesheetHref;
  link.dataset.cartRedesignStylesheet = stylesheetHref;
  document.head.appendChild(link);
}

function getCartDrawerElements() {
  return Array.from(document.querySelectorAll('cart-drawer'));
}

function applyCartDrawerColors(cartDrawer, shouldEnableRedesign) {
  if (!cartDrawer) return;

  const defaultAccentsColor = cartDrawer.dataset.cartDefaultAccentsColor;
  const defaultSecondaryAccentsColor = cartDrawer.dataset.cartDefaultSecondaryAccentsColor;
  const defaultProgressBarBackground = cartDrawer.dataset.cartDefaultProgressBarBackground;

  const redesignAccentsColor = cartDrawer.dataset.cartRedesignAccentsColor;
  const redesignSecondaryAccentsColor = cartDrawer.dataset.cartRedesignSecondaryAccentsColor;
  const redesignProgressBarBackground = cartDrawer.dataset.cartRedesignProgressBarBackground;

  const accentsColor = shouldEnableRedesign ? redesignAccentsColor : defaultAccentsColor;
  const secondaryAccentsColor = shouldEnableRedesign
    ? redesignSecondaryAccentsColor
    : defaultSecondaryAccentsColor;
  const progressBarBackground = shouldEnableRedesign
    ? redesignProgressBarBackground
    : defaultProgressBarBackground;

  if (accentsColor) {
    cartDrawer.style.setProperty('--accents_color', accentsColor);
  }

  if (secondaryAccentsColor) {
    cartDrawer.style.setProperty('--secondary_accents_color', secondaryAccentsColor);
  }

  if (progressBarBackground) {
    cartDrawer.style.setProperty('--progress_bar_background', progressBarBackground);
  }
}

function applyCartRedesignState() {
  const cartDrawers = getCartDrawerElements();
  if (!cartDrawers.length) return false;

  const intelligemsEnabled = isIntelligemsCartRedesignEnabled();
  let hasEnabledDrawer = false;

  cartDrawers.forEach((cartDrawer) => {
    const defaultEnabled = cartDrawer.dataset.cartRedesignDefault === 'true';
    const shouldEnableRedesign = defaultEnabled || intelligemsEnabled;

    if (shouldEnableRedesign) {
      ensureCartRedesignStylesheet(cartDrawer);
      hasEnabledDrawer = true;
    }

    cartDrawer.classList.toggle('cart-redesign', shouldEnableRedesign);
    cartDrawer.dataset.cartRedesignActive = shouldEnableRedesign ? 'true' : 'false';
    applyCartDrawerColors(cartDrawer, shouldEnableRedesign);

    cartDrawer.querySelectorAll('[data-cart-redesign-only]').forEach((element) => {
      element.hidden = !shouldEnableRedesign;
    });

    cartDrawer.querySelectorAll('[data-cart-default-only]').forEach((element) => {
      element.hidden = shouldEnableRedesign;
    });
  });

  return hasEnabledDrawer;
}

window.applyCartRedesignState = applyCartRedesignState;

function setupGlobalCartRedesignObserver() {
  if (window.__cartRedesignGlobalObserver) return;

  let frameId = null;
  const scheduleApply = () => {
    if (frameId) cancelAnimationFrame(frameId);
    frameId = requestAnimationFrame(() => {
      applyCartRedesignState();
    });
  };

  const observer = new MutationObserver(scheduleApply);
  observer.observe(document.documentElement, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['class', 'data-intelligems-cart-redesign', 'data-ig-cart-redesign'],
  });

  if (document.body) {
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'data-intelligems-cart-redesign', 'data-ig-cart-redesign'],
    });
  }

  window.__cartRedesignGlobalObserver = observer;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    applyCartRedesignState();
    setupGlobalCartRedesignObserver();
  });
} else {
  applyCartRedesignState();
  setupGlobalCartRedesignObserver();
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.applyRedesignState = applyCartRedesignState.bind(null);
    this.applyRedesignState();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  lockScroll() {
    if (document.documentElement.classList.contains('cart-drawer-open')) return;

    cartDrawerScrollPosition = window.scrollY || document.documentElement.scrollTop;
    document.documentElement.classList.add('cart-drawer-open');
    document.body.classList.add('overflow-hidden');
    document.body.style.top = `-${cartDrawerScrollPosition}px`;
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
  }

  unlockScroll() {
    if (!document.documentElement.classList.contains('cart-drawer-open')) return;

    document.documentElement.classList.remove('cart-drawer-open');
    document.body.classList.remove('overflow-hidden');
    document.body.style.top = '';
    document.body.style.position = '';
    document.body.style.width = '';
    window.scrollTo({ top: cartDrawerScrollPosition, left: 0, behavior: 'instant' });
    cartDrawerScrollPosition = 0;
  }

  static lockPageScroll() {
    document.querySelector('cart-drawer')?.lockScroll();
  }

  static unlockPageScroll() {
    document.querySelector('cart-drawer')?.unlockScroll();
  }

  open(triggeredBy) {
    this.applyRedesignState();
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn =
          (this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : this.querySelector('#CartDrawer')) ||
          this.querySelector('.drawer__inner') ||
          this;
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    this.lockScroll();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    this.unlockScroll();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.applyRedesignState();
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
